import { Container } from "@/screens/rewards/components/Container"

import BronzeLarge from "@/assets/clipart/rewards/bronze_large.svg"
import SilverLarge from "@/assets/clipart/rewards/silver_large.svg"
import GoldLarge from "@/assets/clipart/rewards/gold_large.svg"
import PlatinumLarge from "@/assets/clipart/rewards/platinum_large.svg"
import DiamondLarge from "@/assets/clipart/rewards/diamond_large.svg"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, BodyBold, H4, H5 } from "@/components/standard/BFText"
import { useRewardsProgramData } from "@/queries/user"
import { numberWithCommas } from "@/utils/NumberUtils"
import { View } from "react-native"

const BADGES = {
  bronze: BronzeLarge,
  silver: SilverLarge,
  gold: GoldLarge,
  platinum: PlatinumLarge,
  diamond: DiamondLarge,
}

export type LevelType = keyof typeof BADGES

export const LevelDiscount = ({
  level,
  className = "",
  postFix = "",
}: {
  level: LevelType
  className?: string
  postFix?: string
}) => {
  const { data: rewardsProgramData } = useRewardsProgramData()

  if (!rewardsProgramData) return null

  const tierData = rewardsProgramData.tiers?.find((t) => t!.name === level)

  if (!tierData) {
    console.warn(`Tier ${level} not found`)
    return null
  }

  const Badge = BADGES[level]

  return (
    <Container className={className}>
      <Horizontal className={"justify-center items-center gap-5"}>
        <View className="flex items-center justify-center w-[62px]">
          <Badge width={64} height={64} />
        </View>
        <Vertical className={"flex-1"}>
          <H4 className={"text-midnight-blue"}>{tierData.label} Discount</H4>
          <H5 className={"text-calm-blue mb-4"}>
            {numberWithCommas(tierData.minPointsRequired)} pts
          </H5>
          <Body className={"text-midnight-blue"}>
            <BodyBold>
              {(tierData.origFeeDiscount! * 100).toLocaleString("en-US", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              })}
              %
            </BodyBold>{" "}
            origination fee discount {postFix}
          </Body>
          {/* <Body className={"text-midnight-blue"}> */}
          {/*  <BodyBold> */}
          {/*    {(tierData.interestRateDiscount! * 100).toLocaleString("en-US", { */}
          {/*      maximumFractionDigits: 2, */}
          {/*      minimumFractionDigits: 2, */}
          {/*    })} */}
          {/*    % */}
          {/*  </BodyBold>{" "} */}
          {/*  interest % discount */}
          {/* </Body> */}
        </Vertical>
      </Horizontal>
    </Container>
  )
}
